<!--
 * @Author: your name
 * @Date: 2022-03-13 02:58:15
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-24 14:56:02
 * @Description: file content
-->
<template>
  <div class="top">
    <TopBar></TopBar>
    <div class="table-wheel" ref="my_wheel_container">
      <LotteryTable
        @end="endOutCallback"
        @start="startOutCallback"
        class="wheel"
        :prizes="prizes"
      />
    </div>
    <div class="lucky-record">
      <span class="word3" @click="read_prizes_record">我的抽奖记录</span>
    </div>
    <!-- 中奖弹框 -->
    <van-overlay :show="prized_flag" z-index="999" lock-scroll>
      <div class="wrapper" @click.stop>
        <Modal v-if="prized_flag" :prize="prize" @prize_get="prize_get"></Modal>
      </div>
    </van-overlay>
    <!-- 中奖记录弹框 -->
    <van-overlay :show="record_flag" z-index="999" lock-scroll>
      <div class="wrapper" @click.stop>
        <LotteryRecord
          v-if="record_flag"
          :record="record"
          @recordExit="record_exit"
        ></LotteryRecord>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import TopBar from "../../components/TopBar";
  import LotteryTable from "../../components/LotteryTable";
  import Modal from "../../components/Modal";
  import LotteryRecord from "../../components/LotteryRecord";
  import {
    getPrizeList,
    getPrizeRecord,
    joinBigWheel,
  } from "@/api/lotteryLucky";
  import { Notify } from "vant";

  // 数字转换汉字函数
  var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  var chnUnitSection = ["", "万", "亿", "万亿", "亿亿"];
  var chnUnitChar = ["", "十", "百", "千"];

  var numToChn = function(num) {
    var index = num.toString().indexOf(".");
    if (index != -1) {
      var str = num.toString().slice(index);
      var a = "点";
      for (var i = 1; i < str.length; i++) {
        a += chnNumChar[parseInt(str[i])];
      }
      return a;
    } else {
      return "";
    }
  };

  //定义在每个小节的内部进行转化的方法，其他部分则与小节内部转化方法相同
  function sectionToChinese(section) {
    var str = "",
      chnstr = "",
      zero = false,
      count = 0; //zero为是否进行补零， 第一次进行取余由于为个位数，默认不补零
    while (section > 0) {
      var v = section % 10; //对数字取余10，得到的数即为个位数
      if (v == 0) {
        //如果数字为零，则对字符串进行补零
        if (zero) {
          zero = false; //如果遇到连续多次取余都是0，那么只需补一个零即可
          chnstr = chnNumChar[v] + chnstr;
        }
      } else {
        zero = true; //第一次取余之后，如果再次取余为零，则需要补零
        str = chnNumChar[v];
        str += chnUnitChar[count];
        chnstr = str + chnstr;
      }
      count++;
      section = Math.floor(section / 10);
    }
    return chnstr;
  }

  //定义整个数字全部转换的方法，需要依次对数字进行10000为单位的取余，然后分成小节，按小节计算，当每个小节的数不足1000时，则需要进行补零

  function TransformToChinese(num) {
    var a = numToChn(num);
    num = Math.floor(num);
    var unitPos = 0;
    var strIns = "",
      chnStr = "";
    var needZero = false;

    if (num === 0) {
      return chnNumChar[0];
    }
    while (num > 0) {
      var section = num % 10000;
      if (needZero) {
        chnStr = chnNumChar[0] + chnStr;
      }
      strIns = sectionToChinese(section);
      strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0];
      chnStr = strIns + chnStr;
      needZero = section < 1000 && section > 0;
      num = Math.floor(num / 10000);
      unitPos++;
    }

    return chnStr + a;
  }

  export default {
    data() {
      //  http://localhost:8080/bigWheel?luckyAwardId=e0c41e49-a09d-49e9-bce6-acd762177f26
      return {
        prizes: [], // 所有奖品 渲染转盘
        prizenames: [], // 所有奖品名称
        prize: {}, // 获奖之后需要传递给立即获奖弹窗
        record: "", // 中奖记录中的奖品名字 传递给立即获取。
        awardGoodsRecordId: "", // 中奖记录的 id
        prized_flag: false,
        record_flag: false,
        turn_flag: false,
        prizeType: "",
        exit_icon: require("../../../../assets/lottery/prize_get.svg"),
        goodsName: "",
      };
    },
    components: {
      LotteryRecord,
      Modal,
      TopBar,
      LotteryTable,
    },
    methods: {
      // 结束抽奖
      endOutCallback(prize) {
        console.group("%c end prize", "color: #f00; font-size: 20px;");
        console.log(prize);
        console.groupEnd();
        let prizeFont = prize.fonts[0];
        this.prize = prize;
        console.log(this.prize, "prize");
        // 改为 判断 subscript 字段
        switch (prizeFont.text) {
          case "一等奖":
          case "二等奖":
          case "三等奖":
          case "四等奖":
          case "五等奖":
          case "六等奖":
            this.prized_flag = true;
            break;
          default:
            this.$notify({
              message: "非常遗憾，您未中奖，谢谢参与！",
              color: "#ad0000",
              background: "#ffe1e1",
            });
            this.prized_flag = false;
        }
        this.turn_flag = false;
      },
      // 开始抽奖
      startOutCallback(myLucky) {
        // 抽奖数据
        joinBigWheel({
          luckyAwardId: this.$route.query.luckyAwardId,
        }).then((res) => {
          // MARK: 抽奖
          if (!(res.code == -1)) {
            // 调用抽奖组件的 play 方法开始游戏
            // 开始之前设置一下 转动标志
            this.turn_flag = true;
            let result = res.data;
            //  请求到得奖数据之后，里面有一个ID 和一个奖品名字
            // 看一下中奖的对应索引。
            if (result.id === null) {
              this.$notify({
                message: "缺少奖品id，请联系管理员!",
                color: "#ad0000",
                background: "#ffe1e1",
              });
              return;
            }
            let index = this.getPrizedIndex(result.id);
            this.awardGoodsRecordId = result.awardGoodsRecordId;
            myLucky.play();
            // 模拟调用接口异步抽奖
            setTimeout(() => {
              // 假设后端返回的中奖索引是0
              //const index = 3;
              // 调用stop停止旋转并传递中奖索引
              // this.$refs.myLucky.stop(index);
              // 默认是按照 range 中设置的几率来进行转盘落点判定，后续会通过 后端传递参数进行指定。
              myLucky.stop(index);
            }, 3000);
          } else {
            myLucky.init();
            console.log("只能参加一次");
            this.turn_flag = false;
          }
        });
      },
      /**
       * 获取中奖奖品在 prizes 里面的索引
       * @param {String} id - 奖品 id
       */
      getPrizedIndex(id) {
        let index;
        for (let idx in this.prizes) {
          if (this.prizes[idx].id == id) {
            this.prize = this.prizes[idx];
            index = idx;
            this.prizeType = this.prizes[idx].prize_info.prizeType;
          }
        }
        return index;
      },
      // 读取抽奖记录弹框切换
      read_prizes_record(event) {
        if (this.record === "") {
          this.read_record();
        }

        if (this.turn_flag) {
          console.log("转盘转动时候不允许获取中奖记录");
        } else {
          this.record_flag = true;
        }
      },
      // 退出抽奖记录
      record_exit(event) {
        this.record_flag = false;
      },
      // 发送网络请求的记录读取
      read_record() {
        getPrizeRecord({
          // luckyAwardId: this.luckyAwardId,
          luckyAwardId: this.$route.query.luckyAwardId,
        }).then((res) => {
          // 获取抽奖记录
          let res_data = res.data;
          if (res_data === null) {
            this.$notify({
              message: "没有抽奖记录",
              color: "#ad0000",
              background: "#ffe1e1",
            });
            return;
          } else {
            let idx = this.getPrizedIndex(res_data.id);
            // this.awardGoodsRecordId 抽奖记录 id
            // this.verified 是否核销
            // MARK:
            switch (res_data.prizeType) {
              case "THANKS":
                this.record = res_data.awardName;
                return;
              case "GOODS":
                console.log(res_data, "res_data");
                TransformToChinese;
                this.goodsName = res_data.goodsName; // 商品名字
                // this.record = res_data.awardName + ":" + this.goodsName; // 商品名字
                // 几等奖 ＋ res_data.awardName
                // this.record = res_data.awardName + ":" + this.goodsName; // 商品名字
                this.record =
                  this.prizes[idx].fonts[0].text + ":" + res_data.awardName;
                break;
              case "RED_PACKET":
                // this.redPacketName = res_data.redPacketName;
                // this.record = res_data.awardName + ":" + this.redPacketName; // 奖品名字
                this.record =
                  this.prizes[idx].fonts[0].text + ":" + res_data.awardName;
                break;
              default:
                break;
            }
            this.awardGoodsRecordId = res_data.awardGoodsRecordId;
            this.verified = res_data.verified;

            if (res_data.verified === true) {
              console.group("%c 已核销", "color: #f00; font-size: 20px;");
              console.log(res_data);
              console.groupEnd();
            } else if (!res_data.verified && res_data.prizeType === "GOODS") {
              // 未核销并有抽奖记录 并且是商品
              // 根据id 查询出来  奖品 ， 将奖品传递给  end 的回调函数
              console.group("%c 显示弹框", "color: #f00; font-size: 20px;");
              console.log(res_data);
              console.groupEnd();
              let index = this.getPrizedIndex(res_data.id);
              this.prize = this.prizes[index];
              this.prized_flag = true;
            }
          }
        });
      },
      // 立即获得奖品
      prize_get() {
        this.prized_flag = false;
        if (this.prizeType === "GOODS") {
          this.$router.push({
            name: "Settle",
            params: { fid: 0 },
            query: { awardId: this.awardGoodsRecordId },
          });
        } else if (this.prizeType === "RED_PACKET") {
          this.$notify({
            message: "红包已发放至您的账户中",
            color: "#006600",
            background: "#ffffff",
          });
        }
      },
    },
    created() {
      getPrizeList({
        luckyAwardId: this.$route.query.luckyAwardId,
      }).then((res) => {
        let prize_list = res.data.mixedPrizeList;
        let prizes = [
          {
            fonts: [
              {
                text: "",
                top: "35%",
                fontColor: "#FFB600",
                fontSize: "14px",
              },
            ],
            background: "#fffee7",
          },
          {
            fonts: [
              {
                text: "",
                top: "35%",
                fontColor: "#FFFFFF",
                fontSize: "14px",
              },
            ],
            background: "#ffbd31",
          },
          {
            fonts: [
              {
                text: "",
                top: "35%",
                fontColor: "#FFB600",
                fontSize: "14px",
              },
            ],
            background: "#fffee7",
          },
          {
            fonts: [
              {
                text: "",
                top: "35%",
                fontColor: "#FFFFFF",
                fontSize: "14px",
              },
            ],
            background: "#ffbd31",
          },
          {
            fonts: [
              {
                text: "",
                top: "35%",
                fontColor: "#FFB600",
                fontSize: "14px",
              },
            ],
            background: "#fffee7",
          },
          {
            fonts: [
              {
                text: "",
                top: "35%",
                fontColor: "#FFFFFF",
                fontSize: "14px",
              },
            ],
            background: "#ffbd31",
          },
        ];

        for (let idx in prize_list) {
          let prize = prize_list[idx];
          // 将具体奖品内容放入我构造的对象中
          prizes[idx].prize_info = prize_list[idx];
          prizes[idx].id = prize_list[idx].id;
          prizes[idx].fonts[0].text = prize_list[idx].prizeName;
          switch (prize.prizeType) {
            case "THANKS":
              prizes[idx].fonts[0].text = "谢谢参与";
              break;
            case "GOODS":
              prizes[idx].fonts[0].text = `${TransformToChinese(
                prize_list[idx].subscript
              )}等奖`;
              this.prizenames.push([
                prizes[idx].fonts[0].text,
                prize.prizeName,
              ]);
              break;
            // MARK: 中奖名称
            case "RED_PACKET":
              prizes[idx].fonts[0].text = `${TransformToChinese(
                prize_list[idx].subscript
              )}等奖`;
              this.prizenames.push([
                prizes[idx].fonts[0].text,
                prize.prizeName,
              ]);
              break;
            default:
              break;
          }
        }
        this.prizes = prizes; // 奖品列表
        this.$store.commit("lottery/UPDATE_PRIZENAMES", {
          prizeNames: this.prizenames,
        });
        this.$store.commit("lottery/UPDATE_EFFECTIVE_END_TIME", {
          effectiveEndTime: ["结束时间:", res.data.effectiveEndTime],
        });
        // this.remark = res.data.remark; // 抽奖活动说明
        this.$store.commit("lottery/UPDATE_REMARK", {
          remark: res.data.remark,
        });
        console.log("get Prizes list end");
        // 读取抽奖记录
        this.read_record();
      });
    },
  };
</script>

<style lang="less" scoped>
  @import "../../var";
  @word-width: 20vw;

  .wrapper {
    .center();
    .flex-column();
    height: 100%;
  }
  .top {
    .center();
    .flex-column();
    width: 100%;
    position: relative;
    .table-wheel {
      width: 100vw;
      height: 60vh;
      background-image: url("~@/assets/lottery/tablebg.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      margin: 0 auto;
      box-sizing: border-box;
      position: relative;
      top: -@top-bar-height*2;
      .center();
    }

    .lucky-record {
      .center();
      flex: 1;
      z-index: 298;
      position: absolute;
      height: 20px;
      bottom: 11vh;
      .word3 {
        width: @word-width;
        height: 20px;
        display: block;
        overflow-wrap: break-word;
        color: #ffffff;
        font-size: 5vw;
        white-space: nowrap;
        line-height: 20px;
        text-align: center;
        margin: -40px 70px 0 0;
      }
    }
  }
</style>
